module.exports = __webpack_public_path__ + "static/media/penIcon.671e4778.svg";